<template>
  <listComponent entityName="contingent_bookingcontingent" title="Liste des réservations" :buttonGroup="true" />
</template>

<script>
import listComponent from '@/components/backoffice/listComponent'

export default {
  components: {
    listComponent
  }
}
</script>

<style lang="scss">
</style>
